import React, { memo as Memo } from 'react';

const Default = Memo(props => {
    return (
        <a className={"Link"} href={props.path} target="_blank" rel="noopener noreferrer">{props.children}</a>
    )
})

export default Default
